export class Money {
  /**
   * Converts a monetary amount to cents (minor units).
   *
   * @param amount - Monetary value in major units (e.g. 5199.60)
   * Can be a number or a numeric string.
   *
   * @returns Amount in cents as an integer (e.g. 519960)
   */
  static toCents(amount: number | string): number {
    return Number((Number(amount) * 100).toFixed(0));
  }

  /**
   * Converts cents (minor units) back to a monetary amount.
   *
   * @param cents - Amount in cents (e.g. 519960)
   * Can be a number or a numeric string.
   *
   * @returns Monetary value in major units with exactly 2 decimal places
   * (e.g. 5199.60)
   */
  static fromCents(cents: number | string): number {
    return Number((Number(cents) / 100).toFixed(2));
  }
}
